function isEmail(email: string) {
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
}

function isNotEmpty(input: string): boolean {
  return input !== '';
}

export { isEmail, isNotEmpty };
